import {Component, OnInit, signal} from '@angular/core';
import {LocalStorage} from '../../storage.class';
import {Router} from '@angular/router';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoginFormState} from './login-form-state.enum';
import {CustomerAreaService} from '../../services/consumer-area/customer-area.service';
import {AuthenticationService} from "../../services/auth/authentication.service";
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        VvrIconComponent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatButton
    ]
})
export class LoginComponent implements OnInit {

    LoginFormState = LoginFormState;

    readonly loginFormState = signal<LoginFormState>(LoginFormState.FillIn);
    readonly errorMessage = signal<string>(null);

    loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required])
    });

    constructor(private authService: AuthenticationService,
                private customerAreaService: CustomerAreaService,
                private router: Router) {
    }

    ngOnInit() {

    }

    login() {
        this.errorMessage.set(null);
        this.loginFormState.set(LoginFormState.Login);
        this.authService.login(this.loginForm.value.email, this.loginForm.value.password).subscribe(
            authResponse => {
                LocalStorage.setUserToken(authResponse.access_token);
                LocalStorage.setUser(authResponse.user);
                this.customerAreaService.reset();
                this.router.navigate(['']);
            }, failReason => {
                this.errorMessage.set(failReason.message);
                if (!this.errorMessage()) {
                    this.errorMessage.set('Kon de server niet bereiken');
                }
                this.loginFormState.set(LoginFormState.FillIn);
            });
    }

    forgotPassword() {
        this.router.navigate(['request-restore-password']);
        return false;
    }

}
